import React from "react";
import { useDispatch } from "react-redux";
import { addToCart } from "../redux/carts/actions";
import { decreaseProductQuantity } from "../redux/products/actions";

const ProductCard = ({ product }) => {
  const { name, category, img_url, price, quantity } = product;

  const dispatch = useDispatch();
  return (
    <div className="lws-productCard">
      <img className="lws-productImage" src={img_url} alt="product" />
      <div className="p-4 space-y-2">
        <h4 className="lws-productName">{name}</h4>
        <p className="lws-productCategory">{category}</p>
        <div className="flex items-center justify-between pb-2">
          <p className="productPrice">
            BDT <span className="lws-price">{price}</span>
          </p>
          <p className="productQuantity">
            QTY <span className="lws-quantity">{quantity}</span>
          </p>
        </div>
        <button
          className="lws-btnAddToCart"
          disabled={quantity < 1 ? true : false}
          onClick={() => {
            dispatch(addToCart(product));
            dispatch(decreaseProductQuantity(product.id));
          }}
        >
          Add To Cart
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
